import { api } from "@/services/api"
import type { MerchantCurrencyCode } from "@/utils/currency"
import { useQuery } from "@tanstack/vue-query"

const LAST_TEN_TRANSACTIONS_TPPLUS_QUERY_KEY =
  "last_ten_transactions_tpplus"
const LAST_TEN_TRANSACTIONS_BEEPAID_GO_QUERY_KEY =
  "last_ten_transactions_beepaid_go"
export type MinimalTransaction = {
  name: string
  createdAt: Date
  amountGross: number
  source: "tpplus" | "beepaid_go"
  version: string | null
  currency: MerchantCurrencyCode
}

const parseMinimalTransaction = (
  transaction: RecursivelyConvertDatesToStrings<MinimalTransaction>
): MinimalTransaction => ({
  ...transaction,
  createdAt: DateFns.parseISO(transaction.createdAt),
})

export const listLastTenTransactionsTpplus = async () => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<MinimalTransaction>[]
  >("/last_ten_transactions/tpplus")
  return body.map((transaction) =>
    parseMinimalTransaction(transaction)
  )
}
export const listLastTenTransactionsBeepaidGo =
  async () => {
    const { body } = await api.get<
      RecursivelyConvertDatesToStrings<MinimalTransaction>[]
    >("/last_ten_transactions/beepaid_go")
    return body.map((transaction) =>
      parseMinimalTransaction(transaction)
    )
  }

export const useLastTenTransactionsTpplus = () =>
  useQuery({
    queryKey: [LAST_TEN_TRANSACTIONS_TPPLUS_QUERY_KEY],
    queryFn: () => listLastTenTransactionsTpplus(),
    refetchInterval: 60 * 1000,
  })

export const useLastTenTransactionsBeepaidGo = () =>
  useQuery({
    queryKey: [LAST_TEN_TRANSACTIONS_BEEPAID_GO_QUERY_KEY],
    queryFn: () => listLastTenTransactionsBeepaidGo(),
    refetchInterval: 60 * 1000,
  })
